<template>
  <div class="dead">
    <DeadPage/>
  </div>
</template>

<script>
// @ is an alias to /src
import DeadPage from '@/components/DeadPage.vue'

export default {
  name: 'dead',
  components: {
    DeadPage
  }
}
</script>
